const heading = {
  baseStyle: {
    color: "#1A202C",
    fontFamily: "Juneau",
  },
  sizes: {
    // спеціально для h3 (size="md" за замовчуванням для h3)
    md: {
      fontSize: "lg",
      fontWeight: "bold",
    },
  },
};

export default heading;
